import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CfagSimulationRequest } from '../models/cfag-simulation-request';
import { CfagSimulationResponse } from '../models/cfag-simulation-response.model';

@Injectable({
  providedIn: 'root',
})
export class CfagSimulationService {
  private readonly http = inject(HttpClient);

  public postCfagSimulation(
    cfagSimulationRequest: Partial<CfagSimulationRequest>,
  ): Observable<CfagSimulationResponse> {
    return this.http.post<CfagSimulationResponse>(
      '/rgg/fis/v1/cfag-simulation',
      cfagSimulationRequest,
    );
  }
}
